import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { LearnsetViewComponent } from "./learnset-view.component";
import { ControlsModule } from "src/app/controls/controls.module";
import { SharedModule } from "src/app/shared/shared.module";
import { CreateFlashcardComponent } from "./create-flashcard/create-flashcard.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { EditLearnsetModule } from "./edit-learnset/edit-learnset.module";
import { SuggestionsComponent } from "./suggestions/suggestions.component";
import { AiChatComponent } from "src/app/shared/ai-chat/ai-chat.component";
import { TablerIconComponent } from "angular-tabler-icons";
import { EditFlashcardComponent } from "./edit-flashcard/edit-flashcard.component";
import { QuillEditorComponent } from "ngx-quill";

@NgModule({
  declarations: [
    LearnsetViewComponent,
    CreateFlashcardComponent,
    SuggestionsComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ControlsModule,
    SharedModule,
    EditLearnsetModule,
    AiChatComponent,
    TablerIconComponent,
    EditFlashcardComponent,
    QuillEditorComponent
],
  exports: [
    LearnsetViewComponent
  ]
})
export class LearnsetViewModule { }